import React from 'react';
import SvgTextEllipsis from "./SvgTextEllipsis";

// 黑色气泡弹框
export const ToolTip = ({showTip, tipObj, zoom = 1}) => {
  if (showTip) {
    const centerX = tipObj.x + (tipObj.width / 2);
    const centerY = tipObj.y + (tipObj.height / 2);
    const radius = 5;
    const width = 150;
    // const height = tipObj.name && tipObj.name.length > 0 ? 60 : 35;
    const height = 45;
    const Y = centerY + height / 2;
    return (
        <g
            transform={`translate(${centerX},${Y}) scale(${1 / zoom},${1 / zoom})`}>
            {!tipObj.contentSvg && tipObj.name &&
            <g>
                <path
                    fill="black"
                    fillOpacity="0.7" d={`M0 0 l10 10 h ${width / 2 - 10 - radius}
          a ${radius} ${radius} 90 0 1 ${radius} ${radius} v ${height}
          a ${radius} ${radius} 90 0 1 ${-radius} ${radius} h ${2 * radius - width}
          a ${radius} ${radius} 90 0 1 ${-radius} ${-radius} v ${-height}
          a ${radius} ${radius} 90 0 1 ${radius} ${-radius} h ${width / 2 - 10 - radius} Z`}
                />
                <text
                    dy="23"
                    dominantBaseline="text-before-edge"
                    fill="white"
                    textAnchor="middle"
                >
                    {tipObj.name}
                </text>
            </g>
            }
            {tipObj.contentSvg &&
            <g>
                {tipObj.contentSvg}
            </g>
            }
        </g>
    );
  } else {
    return null;
  }
};

// 起点svg图标
export const StartPosition = ({
  x,
  y,
  zoom,
  svgPath = () => {
    return (
      <g>
        <path
          fill="#00b65d"
          d="M12.5.22A11.82,11.82,0,0,0,.68,12s0,0,0,0C.68,17,10.54,31.8,12.5,31.8S24.32,16.93,24.32,12.07A11.82,11.82,0,0,0,12.52.22Z"
        />
        <path
          fill="#009e55"
          d="M12.5,32h0c-.23,0-.65-.11-1.56-1C7.66,27.72.44,16.43.44,12.07a12.06,12.06,0,1,1,24.12,0C24.56,16.25,17.34,27.71,14,31,13.14,31.89,12.73,32,12.5,32ZM12.5.46A11.59,11.59,0,0,0,.92,12.07h0c0,4.13,7.1,15.35,10.35,18.59.82.82,1.15.88,1.23.88h0c.08,0,.39-.07,1.2-.86,3.27-3.27,10.4-14.51,10.4-18.61A11.59,11.59,0,0,0,12.5.46Z"
        />
        <circle fill="#ffffff" cx="12.5" cy="12.37" r="5.82" />
        <path
          fill="#009e55"
          d="M12.5,18.45a6.08,6.08,0,1,1,6.08-6.08h0A6.09,6.09,0,0,1,12.5,18.45Zm0-11.64a5.56,5.56,0,1,0,5.55,5.56h0A5.56,5.56,0,0,0,12.5,6.81Z"
        />
      </g>
    );
  }
}) => {
  return (
    <g
      width={25}
      height={32}
      transform={`translate(${x - 12.5 / zoom}, ${y - 32 / zoom})  scale(${1 /
        zoom},${1 / zoom})`}
    >
      {svgPath()}
    </g>
  );
};

// 终点svg图标
export const EndPosition = ({
  x,
  y,
  zoom,
  svgPath = () => {
    return (
      <g>
        <ellipse fill="#fff" cx="12.14" cy="11.99" rx="8.32" ry="8.47" />
        <path
          fill="#ff3536"
          d="M12.46,6.61a5.59,5.59,0,1,0,5.49,5.59h0a5.54,5.54,0,0,0-5.49-5.59Zm3.84,8.75-2-.79a2.12,2.12,0,0,1-.55-.31c-.1-.1-.09-.33,0-.63s1.16-1.49,1.16-2.58c0-1.68-1.08-3-2.42-3s-2.42,1.36-2.42,3a5.67,5.67,0,0,0,1.06,2.51.76.76,0,0,1,0,.67,2,2,0,0,1-.64.31l-1.82.83a5.09,5.09,0,0,1,.72-7.07,4.88,4.88,0,0,1,6.94.74,5.1,5.1,0,0,1,0,6.33Z"
        />
        <path
          fill="#ff3536"
          d="M12.5.51A11.61,11.61,0,0,0,1,12.22H1c0,4.89,9.59,19.53,11.5,19.48S24,17,24,12.22A11.61,11.61,0,0,0,12.5.51ZM12.5,19a6.79,6.79,0,1,1,6.66-6.78A6.72,6.72,0,0,1,12.5,19Z"
        />
        <path
          fill="#f72824"
          d="M12.5,32h0c-.23,0-.63-.11-1.52-1C7.78,27.73.77,16.56.77,12.22A11.86,11.86,0,0,1,12.24,0a11.83,11.83,0,0,1,12,11.68q0,.27,0,.53c0,4.19-7,15.5-10.25,18.77C13.12,31.87,12.72,32,12.5,32ZM12.5.75A11.38,11.38,0,0,0,1.24,12.22c0,4.09,6.9,15.2,10.07,18.4.8.81,1.11.87,1.19.87h0c.08,0,.38-.06,1.16-.84,3.18-3.22,10.11-14.35,10.11-18.43A11.38,11.38,0,0,0,12.5.75Zm0,18.49a7,7,0,0,1-6.9-7,7,7,0,0,1,6.9-7,7,7,0,0,1,6.9,7h0a7,7,0,0,1-6.91,7Zm0-13.58a6.54,6.54,0,1,0,6.43,6.55A6.5,6.5,0,0,0,12.5,5.66Z"
        />
      </g>
    );
  }
}) => (
  <g
    width={25}
    height={32}
    transform={`translate(${x - 12.5 / zoom}, ${y - 32 / zoom}) scale(${1 /
      zoom},${1 / zoom})`}
  >
    {svgPath()}
  </g>
);


// 定位 svg 图标
export const MarkIcon = ({ rotate, width, height, svgWidth, svgHeight, mapElementId, eleSvg, element, svgPath=() => {
  return (
    <g
      fill="red"
      stroke="none"
      fillOpacity="0.6"
    >
      <path
        d="M3.279 41.418c-.094.02-.192.027-.293.02a1.066 1.066 0 0 1-.983-1.14l.019-.275a.967.967 0 0 1
       .038-.54l.194-2.77c0-3.087 2.824-5.083 9.679-8.452 3.2-1.575 3.679-2.095 3.679-3.321
       0-.055-.004-.113-.012-.174-.052-.406-.273-.903-.613-1.422a6.44 6.44 0 0
       0-.68-.872c-.907-.943-1.516-2.334-1.914-4.06a21.09 21.09 0 0 1-.457-3.14 20.67 20.67 0 0
       1-.064-1.567v-.539c0-4.353 1.827-7.261 4.836-8.876a11.128 11.128 0 0 1 3.246-1.12A9.28 9.28 0 0 1 21.481
       3h.543c.325.003.852.047 1.518.17a11.13 11.13 0 0 1 3.246 1.12c3.01 1.615 4.837 4.523 4.837
       8.876v.539c.002.359-.014.9-.064 1.566a21.095 21.095 0 0 1-.458 3.14c-.398 1.727-1.007 3.118-1.915 4.061a6.44
       6.44 0 0 0-.678.872c-.341.519-.562 1.016-.614 1.422a1.363 1.363 0 0 0-.012.174c0 1.226.478 1.746 3.68 3.32
       6.855 3.37 9.678 5.366 9.678 8.453l-.006-.116.397 3.66c.007.057.008.115.005.171l.002.052a.96.96 0 0
       1-.96.96H3.279v-.022zm.904-1.9l.19-2.73c.002-1.86 2.672-3.747 8.49-6.607 3.851-1.894 4.87-3.003 4.87-5.241
       0-.149-.01-.298-.03-.449-.1-.784-.444-1.56-.948-2.327a8.458 8.458 0 0
       0-.925-1.18c-.586-.609-1.052-1.673-1.37-3.055a19.334 19.334 0 0 1-.467-4.214v-.549c0-3.543 1.378-5.738
       3.712-6.99a9.047 9.047 0 0 1 2.631-.904 7.336 7.336 0 0 1 1.154-.135h.525c.2.002.608.036
       1.145.135.901.166 1.8.459 2.632.904 2.333 1.252 3.712 3.447 3.712 6.99v.549a19.335 19.335 0 0 1-.467
       4.214c-.319 1.382-.784 2.446-1.371 3.056-.242.251-.583.66-.924 1.18-.504.766-.848 1.542-.949
       2.326-.02.15-.03.3-.03.449 0 2.238 1.02 3.347 4.87 5.24 5.819 2.861 8.488 4.748 8.488 6.533l.007.116.292
       2.69H4.183z"
        fillRule="evenodd"
      />
    </g>
  )}
}) => {
  const iconWidth = svgWidth ? Number(svgWidth) : 44.25;
  const iconHeight = svgHeight ? Number(svgHeight) : 42.91;
  const x = (width - iconWidth) / 2;
  const y = (height - iconHeight) / 2;
  return (
    <g transform={`translate(${x}, ${y}) rotate(${-rotate},${iconWidth /
      2},${iconHeight / 2})`}>
      { svgPath({width, height, rotate, mapElementId, eleSvg, element,}) }
    </g>
  );
};

// 选中 svg 图标
export const SelectedIcon = ({ rotate, width, height, text, multiple, svgPath=() => {
    return (
    <g transform="translate(5, -5) scale(0.8)">
     <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-532.000000, -600.000000)" fill="#FFC13D" fillRule="nonzero">
            <g transform="translate(527.000000, 589.000000)">
                {multiple &&
                <g>
                    <path d="M27.0102531,11 C14.8531881,11 5,20.855181 5,32.9981718 C5,38.5882954 7.09817366,43.660815 10.5231336,47.5428454 C10.6157001,47.7188307 10.7391221,47.8948161 10.8831144,48.0500973 L25.1794937,63.0192062 C25.2514899,63.1123749 25.323486,63.2158957 25.4057673,63.2987124 C25.6217558,63.5161061 25.8685998,63.6713873 26.136014,63.7852602 C26.9588272,64.1682872 27.9564882,64.0440622 28.625024,63.3711769 C28.8101569,63.1848395 28.9541492,62.9674458 29.0570009,62.7397 L43.0859659,48.0500973 C43.2196731,47.9258723 43.3225247,47.7705911 43.4150912,47.6153099 C46.8811918,43.7332796 48.999968,38.6193517 48.999968,33.0085239 C49.0205061,20.855181 39.1673181,11 27.0102531,11 Z" id="形状"></path>
                    {text && <text dx="26" dy="43" font-size="24" width="44" textAnchor="middle" fill="#fff">{text}</text>}
                </g>}
                {!multiple &&
                <g>
                    <path d="M27.0102531,11 C14.8531881,11 5,20.855181 5,32.9981718 C5,38.5882954 7.09817366,43.660815 10.5231336,47.5428454 C10.6157001,47.7188307 10.7391221,47.8948161 10.8831144,48.0500973 L25.1794937,63.0192062 C25.2514899,63.1123749 25.323486,63.2158957 25.4057673,63.2987124 C25.6217558,63.5161061 25.8685998,63.6713873 26.136014,63.7852602 C26.9588272,64.1682872 27.9564882,64.0440622 28.625024,63.3711769 C28.8101569,63.1848395 28.9541492,62.9674458 29.0570009,62.7397 L43.0859659,48.0500973 C43.2196731,47.9258723 43.3225247,47.7705911 43.4150912,47.6153099 C46.8811918,43.7332796 48.999968,38.6193517 48.999968,33.0085239 C49.0205061,20.855181 39.1673181,11 27.0102531,11 Z M26.9999679,41.9423696 C21.5282601,41.9423696 17.0850689,37.5013269 17.0850689,32.0354283 C17.0850689,26.5695296 21.5282601,22.1284869 26.9999679,22.1284869 C32.4716757,22.1284869 36.9148669,26.5695296 36.9148669,32.0354283 C36.9148669,37.5013269 32.4716757,41.9423696 26.9999679,41.9423696 L26.9999679,41.9423696 Z" id="形状"></path>
                </g>}
            </g>
        </g>
    </g>
    </g>
  );
}}) => {
  const iconWidth = 44.25;
  const iconHeight = 42.91;
  const x = (width - iconWidth) / 2;
  const y = (height - iconHeight) / 2;
  return (
    <g transform={`translate(${x}, ${y}) rotate(${-rotate},${iconWidth /
      2},${iconHeight / 2})`}>
      { svgPath() }
    </g>
  );
}